module.exports = __webpack_public_path__ + "static/media/savio23.1c545c7c.jpg";